import { Box, Button, Checkbox, Container, FormControl, FormControlLabel, Grid, MenuItem, Modal, Paper, Radio, RadioGroup, TextField, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { useFormik } from 'formik'
import { camapignValidationSchema } from './ValidationSchema'
import { toast, ToastContainer } from 'react-toastify'
import { campaignApi, getEducation, getMaritualStatus, getOccupation } from '../asiosConfig'
import OtpVerification from './OtpVerification'
import indSlogan from "../images/FindYourPerfectMatch.png";
import enquiryBg from "../images/inquiryFormDesktop.png";
import ornament from "../images/ornament.png";
import ReCAPTCHA from 'react-google-recaptcha'
import enqRegLogo from "../images/enqRegLogo.png";
import coupleBG from "../images/coupleBG.png";
import indiaLogo from "../images/IndLogo4x.png";
import bottomL from "../images/bottomL.png";
import bottomR from "../images/bottomR.png";
import topL from "../images/topL.png";
import topR from "../images/topR.png";
import axios from 'axios'
import { logEvent } from 'firebase/analytics'
import { analytics } from '../services/firebaseConfig'

const getCampaignId = () => {
    const url = new URL(window.location.href);
    const urlParams = url.searchParams;
    const referrer = urlParams.get('referrer');

    const utm = {
        utm_source: '',
        utm_medium: '',
        utm_campaign: '',
        campaign_id: ''
    };

    // Extract from referrer if exists
    if (referrer) {
        const decodedReferrer = decodeURIComponent(referrer);
        const params = new URLSearchParams(decodedReferrer);
        utm.utm_source = params.get("utm_source") || '';
        utm.utm_medium = params.get("utm_medium") || '';
        utm.utm_campaign = params.get("utm_campaign") || '';
    }

    // Override or fallback to top-level query params
    utm.utm_source = urlParams.get("utm_source") || utm.utm_source;
    utm.utm_medium = urlParams.get("utm_medium") || utm.utm_medium;
    utm.utm_campaign = urlParams.get("utm_campaign") || utm.utm_campaign;
    utm.campaign_id = urlParams.get("campaign_id") || utm.utm_campaign; // fallback to utm_campaign if needed

    return utm;
};



const detectPlatform = () => {
    const ua = navigator.userAgent || navigator.vendor || window.opera;

    // iOS detection
    if (/iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
        return 'ios';
    }

    // Android detection
    if (/android/i.test(ua)) {
        return 'Android';
    }

    return 'Web';
};

export const Campaign = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const [education, setEducation] = useState([]);
    const [occupation, setOccupation] = useState([]);
    const [compaignId, setComapignId] = useState("");
    const [showOtpPopup, setShowOtpPopup] = useState(false);
    const [tokan, setTokan] = useState('')
    const [phoneNumber, setPhoneNumber] = useState('');
    const [captchaVerified, setCaptchaVerified] = useState(false);
    const recaptchaRef = useRef(null);
    const [platform, setPlatform] = useState('Web');
    const [isRegistered, setIsRegistered] = useState(false);
    const [marritalStatuses, setMarritalStatuses] = useState([]);

    // Define the boundaries
    const today = new Date();
    const maxDate = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate())
        .toISOString()
        .split('T')[0];

    const minDate = new Date(today.getFullYear() - 100, today.getMonth(), today.getDate())
        .toISOString()
        .split('T')[0];

    const nameRegex = /^[a-zA-Z\s]*$/;

    const handleNameChange = (e) => {
        const { name, value } = e.target;
        if (nameRegex.test(value)) {
            formik.setFieldValue(name, value);
        }
    };
    const [utmParams, setUtmParams] = useState({
        utm_source: '',
        utm_medium: '',
        utm_campaign: '',
        campaign_id: ''
    });


    useEffect(() => {
        const campaignId = getCampaignId();
        setComapignId(campaignId);
        setUtmParams(getCampaignId());

        const fetchEducation = async () => {
            const response = await getEducation();
            setEducation(response.data.data);
        }

        const fetchOccupation = async () => {
            const response = await getOccupation();
            setOccupation(response.data.data);
        }

        const fetchMarritalStatus = async () => {
            const response = await getMaritualStatus();
            setMarritalStatuses(response.data);
        }

        const logCampaignVisit = async () => {

            // if (sessionStorage.getItem('campaign_tracked')) return;
            try {
                const ipRes = await axios.get('https://api.ipify.org?format=json');
                const ip = ipRes.data.ip;

                logEvent(analytics, 'campaign_visit', {
                    ip,
                    campaignId: compaignId.campaign_id,
                    utm_source: compaignId.utm_source,
                    utm_medium: compaignId.utm_medium,
                    utm_campaign: compaignId.utm_campaign,
                    landing_time: new Date().toISOString(),
                    platform,
                });
                Object.entries(compaignId).forEach(([key, value]) => sessionStorage.setItem(key, value));

                sessionStorage.setItem('campaign_tracked', '1');
            } catch (error) {
                console.log('Error logging campaign visit:', error);
            }
        }

        fetchEducation();
        fetchOccupation();
        fetchMarritalStatus();
        setPlatform(detectPlatform());
        logCampaignVisit();

    }, []);

    const handleCaptchaChange = (value) => {
        setCaptchaVerified(!!value);
    }

    const formik = useFormik({
        initialValues: {
            name: '',
            last_name: '',
            maritalStatus: '',
            phone: '',
            gender: '',
            date_of_birth: '',
            education: '',
            occupation: '',
            terms: false,
            register_platform: platform
        },
        enableReinitialize: true,
        validationSchema: camapignValidationSchema,
        onSubmit: async (values, { resetForm, setSubmitting }) => {
            try {
                const payload = {
                    ...values,
                    ...utmParams
                };

                const response = await campaignApi(payload);

                if (response.status === 200 || response.status == 201) {
                    resetForm();
                    setShowOtpPopup(true);
                    setTokan(response.data.token);
                    setPhoneNumber(values.phone);
                    recaptchaRef.current?.reset();
                    setCaptchaVerified(false);
                } else {
                    toast.error(response.data.message);
                }
            } catch (error) {
                toast.error(error.response.data.message);
            } finally {
                setSubmitting(false)
            }
        }
    })

    const handleOtpSuccess = () => {
        setShowOtpPopup(false);
        setIsRegistered(true);
    };

    return (
        <Box
            sx={{
                minHeight: '100vh',
                backgroundImage: `url(${enquiryBg})`, // Replace with actual image path
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundAttachment: 'fixed',
                display: 'flex',
                flexDirection: 'column',
                py: { xs: 1, sm: 2, md: 2 },
            }}
        >
            <Box mt={1} sx={{ textAlign: 'center', padding: { xs: 1, sm: 3, md: 5 } }}>
                <Container
                    maxWidth="lg"
                    sx={{
                        px: { xs: 1, sm: 2, md: 3 },
                        position: 'relative',
                        width: '100%',
                        maxWidth: { xs: '100%', sm: '95%', md: '1200px' },
                    }}
                >
                    {/* Main Form Container with Responsive Background and Orange Border */}
                    <Box
                        sx={{
                            position: 'relative',
                            width: '100%',
                            minHeight: { xs: '600px', sm: '700px', md: '800px' },
                            backgroundColor: '#fff',
                            borderRadius: { xs: 1, sm: 2, md: 2 },
                            mt: { xs: 1, sm: 2, md: 3 },
                            overflow: 'hidden',
                            boxShadow: { xs: 2, sm: 4, md: 6 },
                            border: '7px solid',
                            borderImageSource: 'linear-gradient(180deg, rgba(255, 119, 5, 0.88), rgba(230, 0, 0, 0.81))',
                            borderImageSlice: 1,
                        }}
                    >
                        {/* New Top Banner */}
                        <Box
                            sx={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: {
                                    xs: '150px', // Height for mobile
                                    sm: '250px', // Height for tablet
                                    md: '400px', // Height for desktop
                                },
                                backgroundColor: '#f9f7f1',
                                zIndex: 0, // Below corner images and other banners
                            }}
                        >
                            {/* Top-Left Image Placeholder (Resizable and Responsive) */}
                            <Box
                                component="img"
                                src={indiaLogo} // Replace with your image path
                                alt="Top Left Banner Image"
                                sx={{
                                    position: 'absolute',
                                    top: { xs: 40, sm: 40, md: 60 },
                                    left: { xs: 40, sm: 60, md: 140 },
                                    width: { xs: '150px', sm: '200px', md: '300px' },
                                    maxWidth: '100%', // Responsive resizing
                                    height: 'auto',
                                    zIndex: 1,
                                }}
                            />
                            <Box
                                component="img"
                                src={indSlogan} // Replace with your image path
                                alt="Top Left Banner Image"
                                sx={{
                                    position: 'absolute',
                                    top: { xs: 100, sm: 150, md: 200 },
                                    left: { xs: 40, sm: 60, md: 140 },
                                    width: { xs: '150px', sm: '200px', md: '300px' },
                                    maxWidth: '100%', // Responsive resizing
                                    height: 'auto',
                                    zIndex: 1,
                                }}
                            />

                            {/* Bottom Image Placeholder */}
                            <Box
                                component="img"
                                src={coupleBG}// Replace with your image path
                                alt="Bottom Banner Image"
                                sx={{
                                    position: 'absolute',
                                    bottom: { xs: 10, sm: 20, md: 30 },
                                    left: '80%',
                                    top: '10%',
                                    transform: 'translateX(-50%)',
                                    width: { xs: '150px', sm: '250px', md: '380px' },
                                    height: 'auto',
                                    zIndex: 1,

                                }}
                            />

                            {/* Center Bottom Image Placeholder */}
                            <Box
                                component="img"
                                src={enqRegLogo} // Replace with your image path
                                alt="Center Bottom Banner Image"
                                sx={{
                                    position: 'absolute',
                                    bottom: { xs: 10, sm: 20, md: 30 },
                                    left: '50%',
                                    top: '90%',
                                    transform: 'translateX(-50%)',
                                    width: { xs: '180px', sm: '250px', md: '380px' },
                                    height: 'auto',
                                    zIndex: 1,
                                }}
                            />
                        </Box>

                        {/* Corner Images */}
                        <Box
                            component="img"
                            src={topR} // Replace with your image path
                            alt="Top Left Corner"
                            sx={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: { xs: '150px', sm: '150px', md: '419px' },
                                height: 'auto',
                                zIndex: 1,
                            }}
                        />
                        <Box
                            component="img"
                            src={topL}// Replace with your image path
                            alt="Top Right Corner"
                            sx={{
                                position: 'absolute',
                                top: 0,
                                right: 0,
                                width: { xs: '150px', sm: '150px', md: '419px' },
                                height: 'auto',
                                zIndex: 1,
                            }}
                        />
                        <Box
                            component="img"
                            src={bottomL} // Replace with your image path
                            alt="Bottom Left Corner"
                            sx={{
                                position: 'absolute',
                                bottom: 0,
                                left: 0,
                                width: { xs: '150px', sm: '150px', md: '419px' },
                                height: 'auto',
                                zIndex: 1,
                            }}
                        />
                        <Box
                            component="img"
                            src={bottomR} // Replace with your image path
                            alt="Bottom Right Corner"
                            sx={{
                                position: 'absolute',
                                bottom: 0,
                                right: 0,
                                width: { xs: '150px', sm: '150px', md: '419px' },
                                height: 'auto',
                                zIndex: 1,
                            }}
                        />
                        <Box
                            align="center"
                            sx={{ mt: { xs: 25, sm: 40, md: 65 }, color: '#333' }} // Adjusted for banner height
                        >

                            <Box
                                sx={{
                                    position: 'relative',
                                    zIndex: 2,
                                    p: {
                                        xs: 2,
                                        sm: 3,
                                        md: 4,
                                    },
                                    // backgroundColor: 'rgba(255, 255, 255, 0.95)', // Semi-transparent white background
                                    // backdropFilter: 'blur(5px)', // Subtle blur effect
                                    borderRadius: { xs: 1, sm: 2 },
                                    mx: { xs: 1, sm: 2, md: 3 },
                                    mb: { xs: 2, sm: 3, md: 4 },
                                    padding: { xs: 2, sm: 3, md: 4 },
                                }}
                            >
                                <form onSubmit={formik.handleSubmit}>
                                    <Grid container spacing={{ xs: 2, sm: 2, md: 3 }} justifyContent="center">
                                        {/* First Name */}
                                        <Grid item xs={12} sm={6}>
                                            <label className='form-label' style={{ fontWeight: 600, fontFamily: 'Montserrat', marginBottom: '8px', display: 'block' }}>
                                                First Name
                                            </label>
                                            <TextField
                                                label="First Name"
                                                fullWidth
                                                name='name'
                                                value={formik.values.name}
                                                onChange={handleNameChange}
                                                error={formik.touched.name && Boolean(formik.errors.name)}
                                                helperText={formik.touched.name && formik.errors.name}
                                                sx={{
                                                    '& .MuiInputBase-root': {
                                                        fontFamily: 'Montserrat',
                                                        fontWeight: 600,
                                                    },
                                                    '& .MuiInputLabel-root': {
                                                        fontFamily: 'Montserrat',
                                                        fontWeight: 600,
                                                    },
                                                    '& .MuiFormHelperText-root': {
                                                        fontFamily: 'Montserrat',
                                                    },
                                                }}
                                            />
                                        </Grid>

                                        {/* Last Name */}
                                        <Grid item xs={12} sm={6}>
                                            <label className='form-label' style={{ fontWeight: 600, fontFamily: 'Montserrat', marginBottom: '8px', display: 'block' }}>
                                                Last Name
                                            </label>
                                            <TextField
                                                label="Last Name"
                                                fullWidth
                                                name='last_name'
                                                value={formik.values.last_name}
                                                onChange={handleNameChange}
                                                error={formik.touched.last_name && Boolean(formik.errors.last_name)}
                                                helperText={formik.touched.last_name && formik.errors.last_name}
                                                sx={{
                                                    '& .MuiInputBase-root': {
                                                        fontFamily: 'Montserrat',
                                                        fontWeight: 600,
                                                    },
                                                    '& .MuiInputLabel-root': {
                                                        fontFamily: 'Montserrat',
                                                        fontWeight: 600,
                                                    },
                                                    '& .MuiFormHelperText-root': {
                                                        fontFamily: 'Montserrat',
                                                    },
                                                }}
                                            />
                                        </Grid>

                                        {/* Gender */}
                                        <Grid item xs={12} sm={6}>
                                            <Box
                                                display="flex"
                                                flexDirection="column"
                                                alignItems="start"
                                                sx={{
                                                    width: '100%',
                                                    justifyContent: 'start', // Ensure Box content is left-aligned
                                                    textAlign: 'start', // Explicitly set text alignment
                                                }}
                                            >
                                                <label
                                                    className='form-label'
                                                    style={{
                                                        fontWeight: 600,
                                                        fontFamily: 'Montserrat',
                                                        marginBottom: '8px',
                                                        width: '100%', // Ensure label takes full width
                                                        textAlign: 'start' // Reinforce left alignment
                                                    }}
                                                >
                                                    Gender
                                                </label>
                                                <RadioGroup
                                                    row
                                                    name="gender"
                                                    value={formik.values.gender}
                                                    onChange={formik.handleChange}
                                                    sx={{
                                                        mt: 1.5,
                                                        flexDirection: { xs: 'column', sm: 'row' },
                                                        gap: { xs: 0, sm: 2 },
                                                        alignItems: 'start', // Use 'start' for cross-browser consistency
                                                        justifyContent: 'start', // Explicitly left-align radio buttons
                                                        width: '100%', // Full width to prevent centering
                                                        textAlign: 'start', // Reinforce left alignment
                                                        '& .MuiRadio-root': {
                                                            padding: { xs: '4px', sm: '9px' }, // Consistent padding
                                                        },
                                                        '& .MuiFormControlLabel-root': {
                                                            margin: 0, // Remove any default margins that could cause centering
                                                            justifyContent: 'start', // Ensure each radio item is left-aligned
                                                        },
                                                    }}
                                                >
                                                    <FormControlLabel
                                                        value="M"
                                                        control={<Radio
                                                            sx={{
                                                                '&.Mui-checked': {
                                                                    '& .MuiSvgIcon-root': {
                                                                        fill: '#fd5d5d',
                                                                    },
                                                                },
                                                            }}
                                                        />}
                                                        label="Male"
                                                        sx={{
                                                            '& .MuiFormControlLabel-label': {
                                                                fontFamily: 'Montserrat',
                                                                fontWeight: 400,
                                                            },
                                                            mr: { xs: 0, sm: 4 },
                                                            alignItems: 'center', // Vertical alignment of radio and label
                                                            justifyContent: 'start', // Ensure left alignment
                                                            width: { xs: '100%', sm: 'auto' }, // Full width on mobile
                                                        }}
                                                    />
                                                    <FormControlLabel
                                                        value="F"
                                                        control={<Radio
                                                            sx={{
                                                                '&.Mui-checked': {
                                                                    '& .MuiSvgIcon-root': {
                                                                        fill: '#fd5d5d',
                                                                    },
                                                                },
                                                            }}
                                                        />}
                                                        label="Female"
                                                        sx={{
                                                            '& .MuiFormControlLabel-label': {
                                                                fontFamily: 'Montserrat',
                                                                fontWeight: 400,
                                                            },
                                                            alignItems: 'center',
                                                            justifyContent: 'start',
                                                            width: { xs: '100%', sm: 'auto' },
                                                        }}
                                                    />
                                                </RadioGroup>
                                                {formik.touched.gender && formik.errors.gender && (
                                                    <div style={{
                                                        color: 'red',
                                                        fontFamily: 'Montserrat',
                                                        fontSize: '0.8rem',
                                                        marginTop: '4px',
                                                        textAlign: 'start', // Ensure error message is left-aligned
                                                        width: '100%'
                                                    }}>
                                                        {formik.errors.gender}
                                                    </div>
                                                )}
                                            </Box>
                                        </Grid>

                                        {/* Phone Number */}
                                        <Grid item xs={12} sm={6}>
                                            <label
                                                className="form-label"
                                                style={{ fontWeight: 600, fontFamily: 'Montserrat', marginBottom: '8px', display: 'block' }}
                                            >
                                                Phone Number
                                            </label>
                                            <TextField
                                                label="Enter Phone Number"
                                                type="tel"
                                                fullWidth
                                                name="phone"
                                                value={formik.values.phone}
                                                onChange={(e) => {
                                                    const onlyDigits = e.target.value.replace(/\D/g, '');
                                                    if (onlyDigits.length <= 10) {
                                                        formik.setFieldValue('phone', onlyDigits);
                                                    }
                                                }}
                                                onBlur={formik.handleBlur}
                                                error={formik.touched.phone && Boolean(formik.errors.phone)}
                                                helperText={formik.touched.phone && formik.errors.phone}
                                                sx={{
                                                    '& .MuiInputBase-root': {
                                                        fontFamily: 'Montserrat',
                                                        fontWeight: 600,
                                                    },
                                                    '& .MuiInputLabel-root': {
                                                        fontFamily: 'Montserrat',
                                                        fontWeight: 600,
                                                    },
                                                    '& .MuiFormHelperText-root': {
                                                        fontFamily: 'Montserrat',
                                                    },
                                                }}
                                                inputProps={{
                                                    maxLength: 10,
                                                    inputMode: 'numeric',
                                                }}
                                            />
                                        </Grid>

                                        {/* Date of Birth */}
                                        <Grid item xs={12} sm={6}>
                                            <label className='form-label' style={{ fontWeight: 600, fontFamily: 'Montserrat', marginBottom: '8px', display: 'block' }}>
                                                Date of Birth
                                            </label>
                                            <TextField
                                                type="date"
                                                fullWidth
                                                name="date_of_birth"
                                                InputLabelProps={{ shrink: true }}
                                                label="Date of Birth"
                                                value={formik.values.date_of_birth || ''}
                                                onChange={formik.handleChange}
                                                error={formik.touched.date_of_birth && Boolean(formik.errors.date_of_birth)}
                                                helperText={formik.touched.date_of_birth && formik.errors.date_of_birth}
                                                inputProps={{
                                                    min: minDate,
                                                    max: maxDate,
                                                }}
                                                sx={{
                                                    '& input': {
                                                        fontFamily: 'Montserrat',
                                                        fontWeight: 600,
                                                        fontSize: '16px',
                                                        WebkitAppearance: 'none',

                                                    },
                                                    '& .MuiInputBase-root': {
                                                        fontFamily: 'Montserrat',
                                                        fontWeight: 600,
                                                    },

                                                    '& .MuiFormHelperText-root': {
                                                        fontFamily: 'Montserrat',
                                                    },
                                                    "& input[type='date']": {
                                                        textAlign: "left",
                                                    },
                                                    "& input[type='date']::-webkit-date-and-time-value": {
                                                        textAlign: "left",
                                                        marginLeft: "0", // Prevent any unwanted offset
                                                    },
                                                }}
                                            />
                                        </Grid>

                                        {/* Marital Status */}
                                        <Grid item xs={12} sm={6}>
                                            <label className='form-label' style={{ fontWeight: 600, fontFamily: 'Montserrat', marginBottom: '8px', display: 'block' }}>
                                                Marital Status
                                            </label>
                                            <TextField
                                                fullWidth
                                                select
                                                label='Marital Status'
                                                variant='outlined'
                                                className='mb-3'
                                                name='maritalStatus'
                                                value={formik.values.maritalStatus}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                error={formik.touched.maritalStatus && Boolean(formik.errors.maritalStatus)}
                                                helperText={formik.touched.maritalStatus && formik.errors.maritalStatus}
                                                sx={{
                                                    '& .MuiInputBase-root': {
                                                        fontFamily: 'Montserrat',
                                                        fontWeight: 400,
                                                    },
                                                    '& .MuiInputLabel-root': {
                                                        fontFamily: 'Montserrat',
                                                        fontWeight: 600,
                                                    },
                                                    '& .MuiSelect-select': {
                                                        fontFamily: 'Montserrat',
                                                        fontWeight: 600,
                                                        textAlign: 'left',
                                                    },
                                                    '& .MuiFormHelperText-root': {
                                                        fontFamily: 'Montserrat',
                                                    },
                                                    '&.Mui-focused fieldset': {
                                                        borderColor: '#ccc',
                                                    },
                                                }}
                                            >
                                                <MenuItem value=''>Select Marital Status</MenuItem>
                                                {marritalStatuses.filter((item) => item.id !== 7).map((item) => (
                                                    <MenuItem key={item.id} value={item.id} sx={{
                                                        fontFamily: 'Montserrat',
                                                        fontWeight: 600,
                                                    }}>
                                                        {item.status}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                        </Grid>

                                        {/* Education */}
                                        <Grid item xs={12} sm={6}>
                                            <label className='form-label' style={{ fontWeight: 600, fontFamily: 'Montserrat', marginBottom: '8px', display: 'block' }}>
                                                Education
                                            </label>
                                            <TextField
                                                fullWidth
                                                select
                                                label='Education'
                                                variant='outlined'
                                                className='mb-3'
                                                name='education'
                                                value={formik.values.education}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                error={formik.touched.education && Boolean(formik.errors.education)}
                                                helperText={formik.touched.education && formik.errors.education}
                                                sx={{
                                                    '& .MuiInputBase-root': {
                                                        fontFamily: 'Montserrat',
                                                        fontWeight: 400,
                                                    },
                                                    '& .MuiInputLabel-root': {
                                                        fontFamily: 'Montserrat',
                                                        fontWeight: 600,
                                                    },
                                                    '& .MuiSelect-select': {
                                                        fontFamily: 'Montserrat',
                                                        fontWeight: 600,
                                                        textAlign: 'left',
                                                    },
                                                    '& .MuiFormHelperText-root': {
                                                        fontFamily: 'Montserrat',
                                                    },
                                                    '&.Mui-focused fieldset': {
                                                        borderColor: '#ccc',
                                                    },
                                                }}
                                            >
                                                <MenuItem value=''>Select Highest Education</MenuItem>
                                                {education.map((item) => (
                                                    <MenuItem key={item.id} value={item.id} sx={{
                                                        fontFamily: 'Montserrat',
                                                        fontWeight: 600,
                                                    }}>
                                                        {item.education}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                        </Grid>

                                        {/* Profession */}
                                        <Grid item xs={12} sm={6}>
                                            <label className='form-label' style={{ fontWeight: 600, fontFamily: 'Montserrat', marginBottom: '8px', display: 'block' }}>
                                                Profession
                                            </label>
                                            <TextField
                                                fullWidth
                                                select
                                                label="Profession"
                                                variant="outlined"
                                                className="mb-3"
                                                name='occupation'
                                                value={formik.values.occupation}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                error={formik.touched.occupation && Boolean(formik.errors.occupation)}
                                                helperText={formik.touched.occupation && formik.errors.occupation}
                                                sx={{
                                                    '& .MuiInputBase-root': {
                                                        fontFamily: 'Montserrat',
                                                        fontWeight: 400,
                                                    },
                                                    '& .MuiInputLabel-root': {
                                                        fontFamily: 'Montserrat',
                                                        fontWeight: 600,
                                                    },
                                                    '& .MuiSelect-select': {
                                                        fontFamily: 'Montserrat',
                                                        fontWeight: 600,
                                                        textAlign: 'left',
                                                    },
                                                    '& .MuiFormHelperText-root': {
                                                        fontFamily: 'Montserrat',
                                                    },
                                                    '&.Mui-focused fieldset': {
                                                        borderColor: '#ccc',
                                                    },
                                                }}
                                            >
                                                <MenuItem value=''>Select Profession</MenuItem>
                                                {occupation.map((item) => (
                                                    <MenuItem key={item.id} value={item.id} sx={{
                                                        fontFamily: 'Montserrat',
                                                        fontWeight: 600,
                                                        fontSize: '1rem',
                                                    }}>
                                                        {item.occupation}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                        </Grid>

                                        {/* Terms Checkbox */}
                                        <Grid item xs={12}>
                                            <FormControl fullWidth margin="none">
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            name="terms"
                                                            checked={formik.values.terms}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            sx={{
                                                                '&.Mui-checked': {
                                                                    color: '#fd5d5d',
                                                                },
                                                                '&.Mui-checked .MuiSvgIcon-root': {
                                                                    fill: '#fd5d5d',
                                                                },
                                                            }}
                                                        />
                                                    }
                                                    label={
                                                        <span style={{ fontFamily: 'Montserrat', fontWeight: 400 }}>
                                                            I have agreed to the{' '}
                                                            <a
                                                                href="/registration-terms"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                style={{
                                                                    color: 'black',
                                                                    fontFamily: 'Montserrat',
                                                                    fontWeight: 600,
                                                                }}
                                                            >
                                                                Terms of Registration
                                                            </a>{' '}
                                                        </span>
                                                    }
                                                />
                                                {formik.touched.terms && formik.errors.terms && (
                                                    <div className="text-danger text-left" style={{ fontSize: 11, fontFamily: 'Montserrat' }}>
                                                        {formik.errors.terms}
                                                    </div>
                                                )}
                                            </FormControl>
                                        </Grid>

                                        {/* ReCAPTCHA */}
                                        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                                            <Box sx={{
                                                transform: {
                                                    xs: 'scale(0.77)',
                                                    sm: 'scale(0.9)',
                                                    md: 'scale(1)'
                                                },
                                                transformOrigin: 'center',
                                                width: { xs: '100%', sm: 'auto' },
                                                overflow: 'hidden'
                                            }}>
                                                <ReCAPTCHA
                                                    ref={recaptchaRef}
                                                    sitekey="6LcfLF8rAAAAABvTykNnEjv_8W4yGZIQRca2nyvw"
                                                    onChange={handleCaptchaChange}
                                                />
                                            </Box>
                                        </Grid>

                                        {/* Submit Button */}
                                        <Grid item xs={12} sm={8} md={6} lg={4} sx={{ display: 'flex', justifyContent: 'center' }}>
                                            <Button
                                                type="submit"
                                                variant="contained"
                                                fullWidth
                                                disabled={formik.isSubmitting || !captchaVerified}
                                                sx={{
                                                    background: "linear-gradient(to right, #f7971e, #fd5d5d)",
                                                    color: "#fff",
                                                    py: { xs: 1.5, sm: 1.8, md: 2 },
                                                    px: { xs: 2, sm: 3, md: 4 },
                                                    fontSize: { xs: '14px', sm: '16px', md: '18px' },
                                                    opacity: formik.isSubmitting || !captchaVerified ? 0.7 : 1,
                                                    cursor: formik.isSubmitting || !captchaVerified ? "not-allowed" : "pointer",
                                                    fontFamily: 'Montserrat',
                                                    fontWeight: 600,
                                                    borderRadius: { xs: 1, sm: 2 },
                                                    boxShadow: '0 4px 15px rgba(253, 93, 93, 0.3)',
                                                    transition: 'all 0.3s ease',
                                                    '&:hover': {
                                                        transform: !formik.isSubmitting && captchaVerified ? 'translateY(-2px)' : 'none',
                                                        boxShadow: !formik.isSubmitting && captchaVerified ? '0 6px 20px rgba(253, 93, 93, 0.4)' : '0 4px 15px rgba(253, 93, 93, 0.3)',
                                                    },
                                                    '&:disabled': {
                                                        background: 'linear-gradient(to right, #ccc, #999)',
                                                    }
                                                }}
                                            >
                                                {formik.isSubmitting ? 'Submitting...' : 'Submit'}
                                            </Button>
                                        </Grid>

                                        {/* Ornament Divider */}
                                        <Grid item xs={12} sx={{ textAlign: "center", mt: 2 }}>
                                            <Box
                                                component="img"
                                                src={ornament}
                                                alt="divider ornament"
                                                sx={{
                                                    width: {
                                                        xs: '60px',
                                                        sm: '80px',
                                                        md: '100px'
                                                    },
                                                    height: 'auto',
                                                    opacity: 0.8,
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </form>
                            </Box>
                        </Box>
                    </Box>
                </Container>
            </Box>

            {/* Toast Container */}
            <ToastContainer
                position={isMobile ? "top-center" : "top-right"}
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                toastStyle={{
                    fontFamily: 'Montserrat',
                    fontSize: isMobile ? '14px' : '16px'
                }}
            />

            {/* OTP Verification Modal */}
            {showOtpPopup && (
                <OtpVerification
                    open={showOtpPopup}
                    onClose={() => setShowOtpPopup(false)}
                    phone={phoneNumber}
                    tokan={tokan}
                    onSuccess={handleOtpSuccess}
                />
            )}
        </Box>
    )
}